<div
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
  data-test="trigger"
  (mouseenter)="isOpen.set(true)"
  (mouseleave)="isOpen.set(false)"
  class="preset-title-4 bg-primary-950 border-secondary-900/30 flex shrink-0 cursor-help items-center rounded-xl border px-3 py-1 shadow-[0_0_10px_rgba(88,202,242,0.2)]">
  <span
    data-test="ranking"
    class="bg-clip-text text-transparent"
    style="background-image: linear-gradient(135deg, var(--color-accent-900) 0%, var(--color-secondary-900) 100%)">
    #{{ ranking() }}
  </span>
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen()"
  [cdkConnectedOverlayPositions]="positions">
  <div
    data-test="tooltip"
    class="from-primary-700 to-primary-950 border-secondary-900/40 relative max-w-52 rounded-xl border bg-gradient-to-b px-4 py-2.5 text-center text-xs text-white shadow-[0_0_16px_rgba(88,202,242,0.35)]">
    <div
      class="mb-2 h-0.5 w-full rounded-full"
      style="background-image: linear-gradient(90deg, var(--color-accent-900), var(--color-secondary-900))"></div>
    <p
      data-test="tooltip-message"
      class="leading-snug text-white/90">
      {{ message() }}
    </p>
    <div
      class="border-t-primary-950 absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent"
      style="border-top-color: var(--color-primary-950)"></div>
  </div>
</ng-template>
